export const contactEmail = "intimex@post.cz";
export const contactPhoneNumber = "+420 596 311 612";
